import styled from 'styled-components';
import { CircularProgress, Container, IconButton } from '@material-ui/core';

export const HeaderWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.primary};
    padding: ${({ theme }) => theme.spacing * 26}px 0 ${({ theme }) => theme.spacing * 4}px 0;
    margin-bottom: ${({ theme }) => theme.spacing * 15}px;
    @media screen and (max-width: 960px) {
        margin-bottom: ${({ theme }) => theme.spacing * 8}px;
    }
`;

export const HeaderContainer = styled(Container)`
    && {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: ${({ theme }) => theme.colors.white};
        > h1 {
            font-size: 36px;
            @media screen and (max-width: 690px) {
                font-size: 24px;
            }
        }

        @media screen and (max-width: 690px) {
            flex-direction: column;
            align-items: flex-start;
        }

        > div {
            display: flex;
            align-items: center;
            @media screen and (max-width: 690px) {
                align-self: flex-end;
            }
        }
    }
`;

export const StyledButton = styled.button`
    border: none;
    font-size: 12px;
    height: 44px;
    padding: 0 32px;
    background-color: ${({ theme }) => theme.colors.white};
    color: black;
    text-transform: uppercase;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.blue};
    border-radius: 6px;
    margin-left: ${({ theme }) => theme.spacing * 6}px;
    cursor: pointer;
    outline: none;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledLoading = styled(CircularProgress)`
    && {
        color: ${({ theme }) => theme.colors.primary};
        margin-right: ${({ theme }) => theme.spacing * 2}px;
    }
`;

export const Button = styled(StyledButton)`
    background-color: unset;
    color:${({ theme }) => theme.colors.white};
    padding: 0;
`;

export const InformationTitle = styled.p`
    margin: 0 0 ${({ theme }) => theme.spacing * 2}px 0;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
    font-size: 14px;
    line-height: 24px;
    font-weight: bold;
`;

export const InformationWrapper = styled.div`
    padding: 24px;
    background-color: #F8FAFD;
    border-radius: 6px;
    width: 380px;
    box-sizing: border-box;
    margin-bottom: ${({ theme }) => theme.spacing * 6}px;
    @media screen and (max-width: 960px) {
        width: auto;
    }
`;

export const InformationName = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    opacity: .87;
    font-size: 12px;
    line-height: 24px;
    font-weight: bold;
`;

export const InformationDescription = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
    font-size: 14px;
    line-height: 21px;
`;

export const FlexWrapper = styled.div`
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing * 15}px;
    > div:first-child {
        margin-right: ${({ theme }) => theme.spacing * 30}px;
    }
    @media screen and (max-width: 960px) {
        justify-content: space-around;
        > div:first-child {
            margin: 0;
        }
    }
`;

export const Numbers = styled(InformationTitle)`
    font-size: 32px;
    line-height: 32px;
`;

export const ChartWrapper = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing * 15}px;
`;

export const StyledInformationWrapper = styled(InformationWrapper)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    @media screen and (max-width: 690px) {
        flex-direction: column;
        align-items: flex-start
    }

    > button {
        border: none;
        font-weight: bold;
        height: 44px;
        padding: 0 ${({ theme }) => theme.spacing * 17}px;
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.white};
        font-size: 12px;
        text-transform: uppercase;
        border-radius: 6px;
        text-align: center;
        cursor: pointer;
        @media screen and (max-width: 690px) {
            margin: ${({ theme }) => theme.spacing * 2}px auto 0;
        }
    }
`;

export const SuspendedWrapper = styled(InformationWrapper)`
    width: 100%;
`;

export const StyledIconButton = styled(IconButton)`
    && {
        color: ${({ theme }) => theme.colors.white};
        margin-left: ${({ theme }) => theme.spacing * 6}px;
        padding: 0;
    }
`;
